/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
//@ts-ignore
import {useTrack} from "../../services/hooks/useTrack"


const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #1e1e1e;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #1e1e1e;
  }
  padding: 0 10px;
  border-radius: 20px;
`;

const InnerContainer = styled.div`
  background-color: #1e1e1e;
  border-radius: 20px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  height: 100%;
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1e1e1e;
  padding: 20px;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;

const Step = styled.div`
  border: 1px solid #7515ed;
  background-color: #7515ed20;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 5px;
`;

const StepNumber = styled.p`
  background-color: #7515ed;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  aspect-ratio: 1 / 1;
  min-width: 0.5em;
  min-height: 0.5em;
  padding: 0.3em;
`;

const StepText = styled.p`
  color: white;
`;

const YellowBold = styled.p`
  display: inline;
  color: #fcde17;
`;

const VerticalSeparator = styled.div`
  border-left: 2px dotted #7515ed;
  height: 30px;
  width: 1px;
  margin-right: -2px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  gap: 20px;
  background-color: #1e1e1e;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 20px;
`;

const Content = styled.p`
  color: white;
  text-align: center;
  padding: 0 20px;
`;

const HorizontalSeparator = styled.div`
  background-color: #7515ed;
  width: 5%;
  min-width: 10px;
  height: 2px;
  min-height: 2px;
`;

export const HowItWorks = () => {
  const {trackEvent} = useTrack()
  
  useEffect(() => {
    trackEvent('Indique - Visualizou modal Como Funciona', {'Tipo da origem': 'Indique e ganhe'})
  }, [])
  return (
    <Container>
      <InnerContainer>
        <StepsContainer>
          <Step>
            <StepNumber>1</StepNumber>
            <StepText>
              Você indica o Blackbook para seus colegas compartilhando seu link
              ou código de indicação.
            </StepText>
          </Step>
          <VerticalSeparator />
          <Step>
            <StepNumber>2</StepNumber>
            <StepText>
              Seus amigos que assinarem o aplicativo ganharão{" "}
              <YellowBold>20% de desconto.</YellowBold>
            </StepText>
          </Step>
          <VerticalSeparator />
          <Step>
            <StepNumber>3</StepNumber>
            <StepText>
              Você ganha <YellowBold>60 Blackcoins</YellowBold> para cada colega
              que assinar o aplicativo.
            </StepText>
          </Step>
        </StepsContainer>
        <ContentContainer>
          <Content>
            Indique amigos, acumule Blackcoins e{" "}
            <YellowBold>troque por prêmios incríveis</YellowBold> na Loja
            Blackbook!
          </Content>
          <HorizontalSeparator />
          <Content>
            <YellowBold>Importante: </YellowBold>os Blackcoins só serão
            liberados se o seu colega não cancelar durante os 7 dias grátis e
            efetivar a assinatura.
          </Content>

          <Content>
            <YellowBold>Que tal começar a indicar agora?</YellowBold>
          </Content>
        </ContentContainer>
      </InnerContainer>
    </Container>
  );
};
